import { getUserAdapter, isPageB2C } from "../gtm/GtmUtils";

/**
 * Rules that change from one implementation to another.
 */
export class SiteRules {
  /**
   * Checks if the current page/section/domain forbids user tracking
   * for legal, functional, or logistical reasons, disabling the library completely.
   * @constructor
   */
  get isGTMLibraryEnabled(): boolean {
    return !isPageB2C();
  }

  /**
   * Check if user is anonymous.
   */
  get isAnonymousUser(): boolean {
    const user = getUserAdapter();
    return !user?.rcId;
  }

  /**
   *  Checks if user tracking is enabled for the current page/section/domain,
   *  allowing specific calls to providers.
   * @constructor
   */
  get isTrackingEnabled(): boolean {
    return true;
  }
}
